import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import PermissionsWarning from '@/components/PermissionsWarning.vue';

export default defineComponent({
  components: {
    PermissionsWarning,
  },
  computed: {
    ...mapGetters({
      getEventPermission: 'Events/getPermission',
      getOrganizationPermission: 'Organizations/getPermission',
      getTicketeersPermission: 'Organizations/getTicketeersPermission',
      getFeatureFlagPermission: 'hasFeatureFlagPermission',
      getTicketeerPermission: 'Organizations/getTicketeerPermission',
    }),
  },
  methods: {
    hasPermission(permission) {
      return !!this.getEventPermission(permission);
    },
    hasOrganizationPermissions(permission) {
      return !!this.getOrganizationPermission(permission);
    },
    hasOrganizationExportPermission() {
      return (
        this.hasOrganizationPermissions('reports.summary.export') ||
        this.hasOrganizationPermissions('reports.revenue.export') ||
        this.hasOrganizationPermissions('reports.attendees.export') ||
        this.hasOrganizationPermissions('reports.blocks.export') ||
        this.hasOrganizationPermissions('reports.groups.export') ||
        this.hasOrganizationPermissions('reports.orders.export')
      );
    },
    hasEventExportPermissions() {
      return (
        this.hasPermission('reports.summary.export') ||
        this.hasPermission('reports.revenue.export') ||
        this.hasPermission('reports.attendees.export') ||
        this.hasPermission('reports.blocks.export') ||
        this.hasPermission('reports.orders.export') ||
        this.hasPermission('reports.groups.export')
      );
    },
    hasTicketeerExportPermissions() {
      return (
        this.hasTicketeersPermissions('reports.ticketsales.export') ||
        this.hasTicketeersPermissions('reports.billing.export') ||
        this.hasTicketeersPermissions('reports.ticketresales.export')
      );
    },
    hasTicketeersPermissions(permission) {
      return !!this.getTicketeersPermission(permission);
    },
    hasTicketeerPermissions(ticketeerId, permission) {
      return !!this.getTicketeerPermission(ticketeerId, permission);
    },
    getTooltipTitle(permission) {
      if (!this.hasPermission(permission)) {
        return this.$i18n.t('permissions.insufficientPermissions');
      }
      return false;
    },
    hasFeatureFlagPermission() {
      return this.getFeatureFlagPermission;
    },
  },
});
